import React from "react";
import PropTypes from "prop-types";
import { withFormik } from "formik";
import BasicCheckbox from "./fields/BasicCheckbox";
import ListView from "../../base/ListView";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { COUNTRIES } from "../../constants/countries";

const _SubContractorsForm = props => {
  const {
    handleSubmit,
    isSubmitting,
    subContractors,
    subContractorsMeta,
    handleDelete,
    values
  } = props;
  const listViewConf = {
    dataSet: subContractors,
    dataMeta: subContractorsMeta,
    columns: [
      {
        key: "name",
        value: "Name"
      },
      {
        key: "addressLine1",
        value: "Address"
      },
      {
        key: "country",
        value: "Country",
        render: item =>
          COUNTRIES.find(country => country.value === item.country)?.label
      }
    ],
    baseFilters: {},
    filters: [],
    actions: {
      deleteLink: true,
      editLink: true,
      detailsLink: false,

      deleteFunction: handleDelete
    },
    url: "/company/subcontractors"
  };
  return (
    <form className="m-login__form m-form" onSubmit={handleSubmit}>
      <div className="m-portlet__body">
        {!subContractors && (
          <div style={{ padding: "2.2rem" }}>
            <div className="m-loader m-loader--accent m-loader--lg mt-2"></div>
          </div>
        )}

        {subContractors && subContractors.length > 0 && (
          <ListView config={listViewConf} />
        )}

        {subContractors && subContractors.length === 0 && (
          <BasicCheckbox
            {...props}
            name={"no_subcontractors"}
            label={
              "I don't have any subcontractors working for me for this edition"
            }
            allowHTML
          />
        )}
      </div>
      <div className="m-portlet__foot">
        <div className="row align-items-center">
          <div className="col-lg-12 m--align-right">
            {!values.no_subcontractors && (
              <Link
                to="/company/subcontractors/create"
                className="m-portlet__nav-link btn btn-success m-btn m-btn--icon"
              >
                <span>
                  <i className="la la-plus" />
                  <span>
                    <Trans>Add Subcontractor</Trans>
                  </span>
                </span>
              </Link>
            )}
            {values.no_subcontractors && (
              <button
                key="1"
                className={
                  "btn m-btn btn-primary" +
                  (isSubmitting
                    ? " m-btn--custom m-loader m-loader--light m-loader--left"
                    : "")
                }
                disabled={isSubmitting}
              >
                Update
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

_SubContractorsForm.propTypes = {
  registration: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const SubContractorsForm = withFormik({
  mapPropsToValues: ({ registration }) => {
    let values = {
      no_subcontractors: !registration.requiresSubcontractors
    };

    return values;
  },

  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values).finally(() => {
      setSubmitting(false);
    });
  }
})(_SubContractorsForm);

export default SubContractorsForm;
